module.exports = {
    DEVELOPMENT_BUILD: true,
    //API_URL: "http://localhost:2401",
    API_URL: "https://api.pneuin.sk",
    TRANSPORT_COST_PER_PIECE: 5,
    TRANSPORT_COST_MAXIMUM_DIAMETER: 24.5,
    CASH_ON_DELIVERY_PRICE: 1.5
}
